import { getApi, getApiById, postApi, putApi } from "../../Shared/Services/RestService";
import { CreateUserRequest, CreateUserRequestForRecruiterRegistration, CreateUserRequestWithEmail, ForgotPasswordRequest, PasswordResetResponse, ResetPasswordRequest, UserForm, UserRegisterResult, userLoginRequest, userLoginResponse, VerifyOtpRequest } from "../Types/UsersType";

export const createUser = (payload: any) => {
  return postApi<UserRegisterResult>("/users/registers", payload);
};

export const createUserWithEmail = (payload: any) => {
  return postApi<CreateUserRequestWithEmail>("/users/register", payload);
};

export const inviteRecruiterUser = (payload: any) => {
  return postApi<CreateUserRequestForRecruiterRegistration>("/recruiter/invites", payload);
};

export const createRecruiterUserFromInvite = (payload: any) => {
  return postApi<CreateUserRequestForRecruiterRegistration>("/recruiter/company-recruiter", payload);
};

export const verifyOtp = (payload: any) => {
  return postApi<VerifyOtpRequest>("/auth/verify-otp", payload);
};

export const loginUser = (payload: any) => {
  return postApi<userLoginResponse>("/auth/login", payload);
};


export const refreshToken = (payload: any) => {
  return postApi<userLoginResponse>("/auth/refresh", payload);
};

export const forgotPassword = (payload: ForgotPasswordRequest) => {
  return postApi<PasswordResetResponse>("/auth/forgot-password", payload);
};

export const resetPassword = (payload: ResetPasswordRequest) => {
  return postApi<PasswordResetResponse>("/auth/reset-password", payload);
};

export const getUserById = (userId: string) => {
  return getApiById<UserForm>("/users", userId);
};

export const updateUser = (payload: any, id: string) => {
  return putApi<UserForm>("/users", id, payload);
};


export const validateEarlyAccessUser = (userId: string) => {
  return getApi<UserForm>(`/users/invitation/validate/${userId}`);
};

/**
 * Switches the signed-in user's own account off. Nothing is deleted — login is blocked
 * until they reactivate or an admin rules on a deletion request. The backend reads the
 * caller from the JWT — no user id is sent.
 */
export const deactivateOwnAccount = (reason: string) => {
  return postApi<null>("/users/me/deactivate", { reason });
};

/** Undoes a self-deactivation. Rejected while a deletion request is still open. */
export const reactivateOwnAccount = () => {
  return postApi<null>("/users/me/reactivate", {});
};

/**
 * Asks for permanent deletion. The reason is mandatory and is what the reviewing
 * SUPER_ADMIN sees. Permanent removal is never self-service — the account is only
 * deactivated here, and an admin has to approve the request for it to actually go.
 */
export const requestAccountDeletion = (reason: string) => {
  return postApi<null>("/users/me/deletion-request", { reason });
};

/**
 * Undoes a self-deactivation by re-authenticating. Returns a live session in the same
 * round trip, so the caller can carry on exactly as it would after a normal sign-in.
 *
 * <p>Public rather than sitting behind the profile page, because a deactivated account
 * cannot sign in and so could never reach a button inside the app.</p>
 */
export const reactivateAccount = (payload: any) => {
  return postApi<any>("/auth/reactivate", payload);
};

